// Requiring modules

module.exports = function (attach) {
  var methods = require('./methods');

  if (attach) {
    require('./native')(methods);
  }

  return methods;
};



//////////////////
// WEBPACK FOOTER
// ../~/i/lib/inflect.js
// module id = 542
// module chunks = 1